module.exports = __webpack_public_path__ + "media/images/logo_cpe_couleur-c94cac46b62adb5d76d562208c4aee32.png";